'use client'

import { useTranslations } from 'next-intl'

import { Button, Chip } from '@graftcode/design-system'

import { NOTIFICATION_DRAWER_FILTER } from '../../const/notification-drawer-filter.const'
import type { NotificationDrawerFilter } from '../../types/notification-drawer-filter.type'

import styles from './NotificationDrawerFilters.module.scss'

type Props = {
  filter: NotificationDrawerFilter
  unreadCount: number
  hasUnread: boolean
  onFilterChange: (filter: NotificationDrawerFilter) => void
  onMarkAllAsRead: () => void
}

export function NotificationDrawerFilters({ filter, unreadCount, hasUnread, onFilterChange, onMarkAllAsRead }: Props) {
  const t = useTranslations('notifications')

  return (
    <div className={styles.filters}>
      <div className={styles.chips}>
        <Chip
          size="l"
          text={t('filters.all')}
          active={filter === NOTIFICATION_DRAWER_FILTER.ALL}
          onClick={() => onFilterChange(NOTIFICATION_DRAWER_FILTER.ALL)}
        />
        <Chip
          size="l"
          text={t('filters.unread', { count: unreadCount })}
          active={filter === NOTIFICATION_DRAWER_FILTER.UNREAD}
          onClick={() => onFilterChange(NOTIFICATION_DRAWER_FILTER.UNREAD)}
        />
      </div>

      {hasUnread ? (
        <Button size="m" variant="ghost" className={styles.markAllButton} onClick={onMarkAllAsRead}>
          {t('markAllAsRead')}
        </Button>
      ) : null}
    </div>
  )
}
